import { render, staticRenderFns } from "./BadgesList.vue?vue&type=template&id=d62c651c"
import script from "./BadgesList.vue?vue&type=script&lang=js"
export * from "./BadgesList.vue?vue&type=script&lang=js"
import style0 from "./BadgesList.vue?vue&type=style&index=0&id=d62c651c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports